import { Dialog } from "@headlessui/react";
import { ComingSoon, Modal } from "components/commons";
import { Breadcum } from "components/commons/Breadcum";
import { useState } from "react";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { pointRewards } from "helpers/constants";

function Point() {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <Breadcum title="Points" />

      <Modal isOpen={isOpen} toggleModal={toggleModal}>
        <Dialog.Title
          as="h3"
          className="text-xl font-normal leading-6 text-white text-center p-4"
        >
          Point Reward{" "}
        </Dialog.Title>

        <div className="border border-gray-800 rounded-xl mx-4 mb-4">
          <div className="text-xs font-medium uppercase flex justify-between border-b border-gray-800">
            <span className="text-slate-300 p-4 border-r border-gray-800 w-[65%]">
              When you...
            </span>
            <span className="text-white p-4">Points</span>
          </div>

          {pointRewards.map((item, idx) => (
            <div
              className="text-xs text-slate-300 font-normal uppercase flex justify-between border-b border-gray-800"
              key={idx}
            >
              <span className="p-4 border-r border-gray-800 w-[65%]">
                {item.action}
              </span>
              <span className="p-4">{item.point}</span>
            </div>
          ))}
        </div>
      </Modal>

      <div className="flex-1 flex flex-col justify-start items-center pt-12">
        <Accordion
          allowMultipleExpanded
          allowZeroExpanded
          className="faqs w-full p-4"
        >
          <div className="space-y-4">
            <div className="border-2 border-gray-800 rounded-xl p-4 space-y-1">
              <div className="  flex items-center gap-2">
                <span className="text-sm text-slate-300">My Points</span>
                <div className="w-4 h-4 rounded-full bg-[#FF9F00] border-[3px] border-[#FFD60A] text-[10px] font-bold flex justify-center items-center">
                  P
                </div>
              </div>
              <div className="text-2xl text-white">0</div>
            </div>
            <AccordionItem className="faqs-card">
              <AccordionItemHeading className="faqs-card_heading">
                <AccordionItemButton className="faqs-card_btn">
                  What are Points?
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel className="faqs-card_body">
                <p>
                  Points represent your activity on fantech and contribute to
                  future rewards.
                </p>
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem className="faqs-card">
              <AccordionItemHeading className="faqs-card_heading">
                <AccordionItemButton className="faqs-card_btn">
                  How to earn Points?{" "}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel className="faqs-card_body">
                <p>
                  Every interaction you make, from uploading to engaging with
                  content, earns you Points.
                </p>
                <div
                  className="underline text-secondary mt-2"
                  onClick={toggleModal}
                >
                  More info{" "}
                  <ArrowTopRightOnSquareIcon className="w-4 h-4 inline mb-1" />
                </div>
              </AccordionItemPanel>
            </AccordionItem>
          </div>
        </Accordion>
      </div>
    </>
  );
}

export { Point as default };
